import { combineEpics, Epic, ofType } from 'redux-observable';
import { mergeMap, Observable } from 'rxjs';
import { changePhase } from '../../../actions/Actions';
import { Phase } from '../../../reducers/State';
import { checkoutResetPaymentSession, resetPaymentState } from '../../payment/actions/Actions';
import { TRY_ANOTHER_CARD } from '../actions/Actions';


const TryAnotherCard: Epic = (action$: Observable<any>): Observable<any> => {
  return action$.pipe(
    ofType(TRY_ANOTHER_CARD),
    mergeMap(() => {
      return [
        changePhase(Phase.Payment),
        resetPaymentState(),
        checkoutResetPaymentSession()
      ];
    })
  );
};

export const EpicResult = combineEpics(TryAnotherCard);
